export function SelectedDetailsHeading({ label, names = [] }: { label: string; names?: string[] }) {
    const selection = names.length > 1 ? `${names.length} selected` : names[0];
    return <span className={`selected-details-heading${selection ? ' selected-details-heading-with-selection' : ''}`}>
        <span>{label}</span>
        {selection && <><span aria-hidden="true"> · </span><span className="selected-details-name" title={names.join(', ')}>{selection}</span></>}
    </span>;
}
